import DropdownIndicator from "./DropdownIndicator";
import MenuList from "./MenuList";
import Placeholder from "./Placeholder";
import ValueContainer from "./ValueContainer";

const components = {
  ClearIndicator: () => null,
  DropdownIndicator,
  IndicatorSeparator: () => null,
  MenuList,
  Placeholder,
  ValueContainer
};

export default components;